/**
 * Page Content Storage Service
 * Handles persistence of page content (BlockNote blocks) to localStorage
 */

const CONTENT_KEY_PREFIX = 'freshcards:content:';

/**
 * Save page content to localStorage
 */
export function savePageContent(pageId: string, blocks: any[]): void {
  try {
    const key = CONTENT_KEY_PREFIX + pageId;
    localStorage.setItem(key, JSON.stringify(blocks));
  } catch (error) {
    console.error('[ContentStorage] Failed to save content for page:', pageId, error);
  }
}

/**
 * Load page content from localStorage
 */
export function loadPageContent(pageId: string): any[] | null {
  try {
    const key = CONTENT_KEY_PREFIX + pageId;
    const data = localStorage.getItem(key);
    if (data) {
      return JSON.parse(data);
    }
  } catch (error) {
    console.error('[ContentStorage] Failed to load content for page:', pageId, error);
  }
  return null;
}

/**
 * Delete page content from localStorage
 */
export function deletePageContent(pageId: string): void {
  try {
    const key = CONTENT_KEY_PREFIX + pageId;
    localStorage.removeItem(key);
  } catch (error) {
    console.error('[ContentStorage] Failed to delete content for page:', pageId, error);
  }
}

/**
 * Check if page has content
 */
export function hasPageContent(pageId: string): boolean {
  const key = CONTENT_KEY_PREFIX + pageId;
  return localStorage.getItem(key) !== null;
}

/**
 * Get all page IDs that have content
 */
export function getAllPageContentIds(): string[] {
  const ids: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith(CONTENT_KEY_PREFIX)) {
      const pageId = key.substring(CONTENT_KEY_PREFIX.length);
      ids.push(pageId);
    }
  }
  return ids;
}

export default {
  savePageContent,
  loadPageContent,
  deletePageContent,
  hasPageContent,
  getAllPageContentIds
};